(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tanca-footer"] && !Shopify.designMode) return;
  try {
    
  /* La metà superiore della fascia del riquadro deve avere il fondo della
     sezione con cui finisce la pagina, che cambia da pagina a pagina (avorio,
     sabbia, scuro...). Si prende il colore dell'elemento più interno che
     copre tutta la larghezza in fondo all'ultima sezione; se non se ne trova
     uno resta lo schema impostato nella sezione. */
  (() => {
    const footer = document.querySelector('.tanca-footer');
    if (!footer) return;

    const sections = [...document.querySelectorAll('main > .shopify-section')].filter(
      (section) => section.offsetHeight > 0
    );
    const last = sections[sections.length - 1];
    if (!last) return;

    const box = last.getBoundingClientRect();
    let color = null;
    for (const element of [last, ...last.querySelectorAll('*')]) {
      const rect = element.getBoundingClientRect();
      if (rect.width < box.width * 0.9 || Math.abs(rect.bottom - box.bottom) > 2) continue;
      const background = getComputedStyle(element).backgroundColor;
      if (background && background !== 'transparent' && !/rgba\(.*,\s*0\)$/.test(background)) {
        color = background;
      }
    }
    if (!color) return;
    footer.style.setProperty('--tanca-footer-paper', color);

    // Se la pagina finisce con lo stesso colore del riquadro (es. sabbia sul
    // Gin) il riquadro sparirebbe: allora prende il fondo chiaro della pagina.
    const panel = footer.querySelector('.tanca-footer__panel');
    if (panel && getComputedStyle(panel).backgroundColor === color) {
      footer.classList.add('tanca-footer--panel-light');
    }
  })();

  /* Le tre rassicurazioni devono avere lo stesso numero di righe (richiesta
     del 29/10/2026). I testi hanno lunghezze simili, ma a certe larghezze uno
     va a capo una volta in meno: a quel testo si stringe la misura quanto
     basta per arrivare alle righe degli altri. */
  (() => {
    const texts = [...document.querySelectorAll('.tanca-footer__assurance-text')];
    if (texts.length < 2) return;

    const linesOf = (text) =>
      Math.round(text.getBoundingClientRect().height / parseFloat(getComputedStyle(text).lineHeight));

    const equalize = () => {
      texts.forEach((text) => text.style.removeProperty('max-width'));
      const target = Math.max(...texts.map(linesOf));

      for (const text of texts) {
        if (linesOf(text) >= target) continue;
        let low = 0;
        let high = text.getBoundingClientRect().width;
        while (high - low > 1) {
          const middle = (low + high) / 2;
          text.style.maxWidth = `${middle}px`;
          if (linesOf(text) >= target) low = middle;
          else high = middle;
        }
        text.style.maxWidth = `${Math.floor(low)}px`;
      }
    };

    let frame = 0;
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(equalize);
    };
    new ResizeObserver(schedule).observe(texts[0].closest('.tanca-footer__panel'));
    document.fonts?.ready.then(schedule);
    schedule();
  })();

  } catch(e) { console.error(e); }
})();
})();
